import { db } from '../firebase';
import { deleteDoc, doc, getDocs, collection, setDoc } from 'firebase/firestore';
import {getAllAccounts} from "./Account";

export const getAllAdmins = async () => {
  const querySnapshot = await getDocs(collection(db, 'admins'));
  
  let admins = [];
  let users = [];

  await getAllAccounts().then((response) => {
    users = response;
  });
  
  querySnapshot.forEach((doc) => {
    admins.push({
      ...doc.data(),
      ...users.find(user => user.uid === doc.data().uid)
    });
  });
  return admins;
};

export const deleteAdmin = async (uid) => {
  await deleteDoc(doc(db, 'admins', uid));
};

export const setAdmin = async (uid) => {
  if (uid !== null) {
    await setDoc(doc(db, 'admins', uid), { uid });
  }

  return true;
};
